import { render, staticRenderFns } from "./JgpUserInfo.vue?vue&type=template&id=0a3fd506&"
import script from "./JgpUserInfo.vue?vue&type=script&lang=js&"
export * from "./JgpUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports